import { useState, useEffect } from "react";
import { EventDates } from "../types";

export function useEventDates(type?: "live_event" | "exam") {
  const [dates, setDates] = useState<EventDates>({ liveEvents: {}, exams: {} });
  useEffect(() => {
    fetch("/wp-json/ganjier-calendar/bookings")
      .then((res) => res.json())
      .then(({ ganjier_2_day_live_dates, ganjier_exam_date }) => {
        setDates({
          liveEvents:
            !type || type === "live_event" ? ganjier_2_day_live_dates : [],
          exams: !type || type === "exam" ? ganjier_exam_date : [],
        });
      });
  }, []);
  return dates;
}
